import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "faceRecognition"
const FaceRecognitionIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.984 21.972c.086.018.175.028.266.028h4.261v-1.875H3.875v-3.636H2v4.261a1.254 1.254 0 0 0 .158.608 1.256 1.256 0 0 0 .826.614Zm.891-14.46H2V3.25a1.255 1.255 0 0 1 .158-.608A1.256 1.256 0 0 1 3.25 2h4.261v1.875H3.875v3.636ZM20.75 2h-4.261v1.875h3.636v3.636H22V3.25a1.258 1.258 0 0 0-.158-.608A1.256 1.256 0 0 0 20.75 2ZM22 20.75v-4.261h-1.875v3.636h-3.636V22h4.261a1.258 1.258 0 0 0 .608-.158A1.255 1.255 0 0 0 22 20.75ZM14.5 9.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm2.5 6.25c0-1.381-2.238-2.5-5-2.5s-5 1.119-5 2.5V17h10v-1.25Z"
      />
    </svg>
  )
}
export default FaceRecognitionIcon
